export const POSITIONS_CSV_HEADERS = [
  "Position Name",
  "Entity",
  "Client",
  "Status",
  "Investing Account",
  "Creation Date",
  "Program",
  "Risk Rating",
  "Onboarding Status",
];
